interface CertGuideProcess {
  id: number;
  texts: Array<{
    text: string;
    bold: boolean;
  }>
  imageUrl: string;
}

export const certGuideProcess: CertGuideProcess[] = [
  {
    id: 1,
    texts: [
      {
        text: `공동인증서가 있는
        데스크탑(PC)`,
        bold: true,
      },
      {
        text: '를 켜주세요.',
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide1.svg',
  },
  {
    id: 2,
    texts: [
      {
        text: '\'더낸세금 공동인증센터\'',
        bold: true,
      },
      {
        text: `를 검색해
        공동인증센터에 들어가 주세요.`,
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide2.svg',
  },
  {
    id: 3,
    texts: [
      {
        text: `더낸세금 공동인증센터에서
        `,
        bold: false,
      },
      {
        text: '프로그램을 설치',
        bold: true,
      },
      {
        text: ' 해주세요.',
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide3.svg',
  },
  {
    id: 4,
    texts: [
      {
        text: `공동인증센터에
        `,
        bold: false,
      },
      {
        text: '인증코드 5자리를 입력',
        bold: true,
      },
      {
        text: '해주세요.',
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide4.svg',
  },
  {
    id: 5,
    texts: [
      {
        text: '등록하실 ',
        bold: false,
      },
      {
        text: '공동인증서를 선택',
        bold: true,
      },
      {
        text: '해주세요.',
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide5.svg',
  },
  {
    id: 6,
    texts: [
      {
        text: `공동인증서 등록이 완료되면
        `,
        bold: false,
      },
      {
        text: '더낸세금 모바일 홈으로 이동',
        bold: true,
      },
      {
        text: '해주세요.',
        bold: false,
      },
    ],
    imageUrl: '/img/icons/cert-guide6.svg',
  },
]
